import { useCallback, useEffect, useRef, useState } from 'react'
import throttle from 'lodash/throttle'
import useDebouncedValue from '../../../../../hooks/useDebounceValue'

const DEBOUNCE_MS = 300
const THROTTLE_MS = 300

export default function useDebouncedThrottledCommit (onCommit) {
  const [inputValue, setInputValue] = useState('')
  const [throttledValue, setThrottledValue] = useState('')

  const throttledSetter = useRef(
    throttle((value) => setThrottledValue(value), THROTTLE_MS, {
      leading: true,
      trailing: true
    })
  ).current

  useEffect(() => {
    throttledSetter(inputValue)
  }, [inputValue, throttledSetter])

  useEffect(() => () => throttledSetter.cancel(), [throttledSetter])

  const debouncedValue = useDebouncedValue(throttledValue, DEBOUNCE_MS)

  useEffect(() => {
    onCommit(debouncedValue)
  }, [debouncedValue, onCommit])

  const clearInput = useCallback(() => {
    throttledSetter.cancel()
    setInputValue('')
    setThrottledValue('')
    onCommit('')
  }, [onCommit, throttledSetter])

  return {
    inputValue,
    setInputValue,
    clearInput
  }
}
